import { createTrackingUtils } from "..";

const utils = createTrackingUtils({
  name: "flights_lve_merch_toolkit_offer_highlighting",
  stages: {},
  defaultStage: 1,
  goals: {
    featured_offer_click: 1,
    next_search_page_navigation: 2
  }
});

export default utils;
